import algoliasearch from 'algoliasearch';

import { StringConstantsMixin } from '../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { lngLatBoundsToAlgoliaBounds } from './at_map_helpers';

export class Search {
  constructor({ indexId }) {
    // todo: consider moving these hard-coded values into a config file somewhere
    this.algoliaRef = algoliasearch('9IOACG5NHE', '63a3cf94e0042b9c67abf0892fc1d223');
    this.algoliaIndex = this.algoliaRef.initIndex(indexId);
  }

  performSearch(queryObj) {
    return this.algoliaIndex.search('', queryObj).catch(e => {
      console.error(e);
    });
  }

  performBatchSearch(queryObjs) {
    const queries = queryObjs.map(q => {
      return {
        indexName: this.algoliaIndex.indexName,
        query: '',
        params: q
      };
    });

    return this.algoliaRef.multipleQueries(queries);
  }
}

const createAlgoliaTrailsObject = map => {
  return {
    hitsPerPage: 5000,
    insideBoundingBox: lngLatBoundsToAlgoliaBounds(map),
    facetFilters: ['type:trail']
  };
};

let defaultIndex;
const getSearchIndex = (indexId = StringConstantsMixin.constants.ALGOLIA.INDEX) => {
  if (defaultIndex) {
    return defaultIndex;
  }
  defaultIndex = new Search({
    indexId
  });
  return defaultIndex;
};

let pendingIndex;
const getPendingSearchIndex = () => {
  if (pendingIndex) {
    return pendingIndex;
  }
  pendingIndex = new Search({
    indexId: StringConstantsMixin.constants.ALGOLIA.PENDING_INDEX
  });
  return pendingIndex;
};

export { createAlgoliaTrailsObject, getSearchIndex, getPendingSearchIndex };
